import { render, staticRenderFns } from "./importedDocsList.vue?vue&type=template&id=7dcc2807&"
import script from "./importedDocsList.vue?vue&type=script&lang=js&"
export * from "./importedDocsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports